import { withTracking } from '../../../observability';
import { SectionName } from '../../../observability/tracking/events';
import { createBuilderModule } from '../../../builder';
import { TestimonialSolo } from './TestimonialSolo';
import { COLOR_KEYS } from '../../../constants';

export default createBuilderModule(
  withTracking(TestimonialSolo, { sectionName: SectionName.TestimonialSolo }),
  {
    name: 'TestimonialSolo',
    image:
      'https://cdn.zapier.com/storage/photos/6ec78ee3777a52da2ffc3bae90191973.png',
    inputs: [
      {
        name: 'background',
        type: 'string',
        enum: [
          COLOR_KEYS.lava10,
          COLOR_KEYS.ocean10,
          COLOR_KEYS.sun10,
          COLOR_KEYS.white,
          // V5 Colors
          COLOR_KEYS.blue10,
          COLOR_KEYS.cream,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral200,
        ],
        defaultValue: 'neutral100',
      },
      {
        name: 'quote',
        type: 'richText',
        defaultValue: 'This is a default quote (Edit me)',
        required: true,
      },
      {
        name: 'author',
        type: 'string',
        defaultValue: 'Name Surname',
        required: true,
      },
      {
        name: 'company',
        type: 'string',
        defaultValue: 'Zapier',
        required: true,
      },
      {
        name: 'hasAuthorAvatar',
        type: 'boolean',
        defaultValue: true,
      },
      {
        name: 'avatarUrl',
        type: 'cloudinaryImage',
        defaultValue:
          'https://cdn.zappy.app/5451454a0209e3d746a5f7c2f1a34aff.png',
      },
    ],
  },
);
